import { useSelector, useDispatch } from 'react-redux';
import { Offcanvas } from 'react-bootstrap';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from "react-router";
import { ActionTypes } from "../../redux/constants";
import axios from "axios";
import Section from '../section/Section';
import OrderHeader from '../../models/OrderHeader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Cart = (props) => {
    const { cartMobile, currentPage, pastOrders } = props;
    let location = useLocation();
    const navigate = useNavigate();
    // eslint-disable-next-line no-unused-vars
    const { orderHeader, cartUpdate } = useSelector((state) => ({orderHeader: state.orderHeader, cartUpdate: state.cartUpdate}));
    const [show, setShow] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editItem, setEditItem] = useState({item: {}, index: 0});
    const { tablecode } = useParams();
    const dispatch = useDispatch();

    const deleteItemHandler = (index) => {
        orderHeader.deleteOrderDetails(orderHeader.orderDetails[index], index);
        setShowEdit(false);
        setShow(true);
    }

    const editItemHandler = (item, index) => {
        setEditItem({item: item.menuItem, index: index});
        setShow(false);
        setShowEdit(true);
    }

    const finishEditHandler = () => {
        setShow(true);
        setShowEdit(false);
    }

    const clearCartHandler = () => {
        orderHeader.clearOrderDetails();
        setShow(false);
    }

    const [utensils, setUtensils] = useState(false);
    const [napkins, setNapkins] = useState(false);

    const updateCartDi = () => {
        axios.get("https://guest-rest-development.getkluck.com/pos/orderForTable/" + tablecode)
        .then((response) => {
            console.log(response)
            let newData = response.data;
            const cart = new OrderHeader();

            cart.address1 = newData.address1;
            cart.address2 = newData.address2;
            cart.authorizedEmployeeId = newData.authorizedEmployeeId;
            cart.authorizedTimestamp = newData.authorizedTimestamp;
            cart.city = newData.city;
            cart.clientId = newData.clientId;
            cart.compAmount = newData.compAmount;
            cart.compGroupId = newData.compGroupId;
            cart.compNote = newData.compNote;
            cart.compReasonId = newData.compReasonId;
            cart.compTotal = newData.compTotal;
            cart.cookingStatus = newData.cookingStatus;
            cart.guestInfoDisplayed = newData.guestInfoDisplayed;
            cart.guestName = newData.guestName;
            cart.locationId = newData.locationId;
            cart.menuId = newData.menuId;
            cart.message = newData.message;
            cart.notes = newData.notes;
            cart.numberOfGuests = newData.numberOfGuests;
            cart.orderDetails = newData.orderDetails;
            cart.orderEmployees = newData.orderEmployees;
            cart.orderHeaderId = newData.orderHeaderId;
            cart.orderModeId = newData.orderModeId;
            cart.orderSourceId = newData.orderSourceId;
            cart.orderTypeId = newData.orderTypeId;
            cart.phoneNumber = newData.phoneNumber;
            cart.postalCode = newData.postalCode;
            cart.promiseTime = newData.promiseTime;
            cart.properties = newData.properties;
            cart.salesTax = newData.salesTax;
            cart.seatingAreaId = newData.seatingAreaId;
            cart.serverName = "Dine In"
            //cart.serverName = newData.serverName; 
            cart.state = newData.state;
            cart.status = newData.status;
            cart.subTotal = newData.subTotal;
            cart.tableName = newData.tableName;
            cart.taxable = newData.taxable;
            cart.terminalName = newData.terminalName;
            cart.timeStamp = newData.timeStamp;
            cart.tip = newData.tip;
            cart.tipPercent = newData.tipPercent;
            cart.total = newData.total;
            cart.userId = newData.userId;
            cart.voidReasonId = newData.voidReasonId;
            dispatch({type: ActionTypes.CREATE_CART, payload: {cart: cart}});
        })
        .catch((error) => console.log("ERROR:" + error));
    }

    const [timeOption, setTimeOption] = useState("ASAP");
    // eslint-disable-next-line no-unused-vars
    const [currentDate, setCurrentDate] = useState(new Date());
    const [setDate, setSetDate] = useState(new Date());
    
    
    return(
        <>
            {!cartMobile &&
                <div onClick={() => setShow(!show)} className={window.location.href.includes("/checkout") ? "cartButtonCO" : pastOrders ? "cartButton cartNotMobile cartPastOrders" : "cartButton cartNotMobile"}>
                    <svg viewBox="0 0 22.5 22.5">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 1.25C0 1.05109 0.0790176 0.860322 0.21967 0.71967C0.360322 0.579018 0.551088 0.5 0.75 0.5H3C3.1673 0.500046 3.32978 0.556026 3.4616 0.659037C3.59342 0.762048 3.68701 0.906176 3.7275 1.0685L4.335 3.5H21.75C21.8601 3.5001 21.9689 3.52445 22.0685 3.57133C22.1682 3.6182 22.2563 3.68644 22.3266 3.77121C22.3969 3.85597 22.4477 3.95518 22.4753 4.06178C22.5029 4.16838 22.5068 4.27976 22.4865 4.388L20.2365 16.388C20.2043 16.5599 20.1131 16.7151 19.9786 16.8268C19.8442 16.9386 19.6749 16.9998 19.5 17H6C5.82515 16.9998 5.65585 16.9386 5.52137 16.8268C5.38688 16.7151 5.29567 16.5599 5.2635 16.388L3.015 4.4105L2.415 2H0.75C0.551088 2 0.360322 1.92098 0.21967 1.78033C0.0790176 1.63968 0 1.44891 0 1.25ZM4.653 5L6.6225 15.5H18.8775L20.847 5H4.653ZM7.5 17C6.70435 17 5.94129 17.3161 5.37868 17.8787C4.81607 18.4413 4.5 19.2044 4.5 20C4.5 20.7956 4.81607 21.5587 5.37868 22.1213C5.94129 22.6839 6.70435 23 7.5 23C8.29565 23 9.05871 22.6839 9.62132 22.1213C10.1839 21.5587 10.5 20.7956 10.5 20C10.5 19.2044 10.1839 18.4413 9.62132 17.8787C9.05871 17.3161 8.29565 17 7.5 17ZM18 17C17.2044 17 16.4413 17.3161 15.8787 17.8787C15.3161 18.4413 15 19.2044 15 20C15 20.7956 15.3161 21.5587 15.8787 22.1213C16.4413 22.6839 17.2044 23 18 23C18.7957 23 19.5587 22.6839 20.1213 22.1213C20.6839 21.5587 21 20.7956 21 20C21 19.2044 20.6839 18.4413 20.1213 17.8787C19.5587 17.3161 18.7957 17 18 17ZM7.5 18.5C7.10218 18.5 6.72065 18.658 6.43934 18.9393C6.15804 19.2206 6 19.6022 6 20C6 20.3978 6.15804 20.7794 6.43934 21.0607C6.72065 21.342 7.10218 21.5 7.5 21.5C7.89783 21.5 8.27936 21.342 8.56066 21.0607C8.84196 20.7794 9 20.3978 9 20C9 19.6022 8.84196 19.2206 8.56066 18.9393C8.27936 18.658 7.89783 18.5 7.5 18.5ZM18 18.5C17.6022 18.5 17.2206 18.658 16.9393 18.9393C16.658 19.2206 16.5 19.6022 16.5 20C16.5 20.3978 16.658 20.7794 16.9393 21.0607C17.2206 21.342 17.6022 21.5 18 21.5C18.3978 21.5 18.7794 21.342 19.0607 21.0607C19.342 20.7794 19.5 20.3978 19.5 20C19.5 19.6022 19.342 19.2206 19.0607 18.9393C18.7794 18.658 18.3978 18.5 18 18.5Z"/>
                    </svg>
                    <div>Cart</div>
                    {orderHeader.orderDetails.length > 0 &&
                        <>&nbsp;({orderHeader.orderDetails.length})</>
                    }
                </div>
            }
            {cartMobile &&
                <div className="bottomBarButton" onClick={() => props.changePage("Cart")}>
                    <svg viewBox="0 0 24 24">
                        <path className={currentPage === "Cart" ? "currentPage" : null} d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z" />
                    </svg>
                    <p className={currentPage === "Cart" ? "currentPage" : null}>Cart</p>
                </div>
            }
            {showEdit && 
                <Section children={[]} editMenuItem={editItem.item} editMode={true} editIndex={editItem.index} finishEditHandler={finishEditHandler} deleteItemHandler={deleteItemHandler} />
            }
            <Offcanvas className={window.location.href.includes("/checkout") ? "cart cartCO" : "cart"} show={cartMobile ? currentPage === "Cart" : show} onHide={() => setShow(!show)} placement="end">
                <div className="cartHeader">
                    <div>Your Items</div>
                    <Offcanvas.Header closeButton onClick={window.location.href.includes("/oo/") ? () => props.changePage("Home") : null} />
                </div>
                <div className="cartItemsContainer">
                    {orderHeader.orderDetails.length === 0 && 
                        <div className="cartNoItems">You don't have any items in your cart</div>
                    }
                    {
                        orderHeader.orderDetails.map((item, index1) => {
                            return (
                                <div className="cartItemDiv" key={index1}>
                                    <div className="cartItemImgDiv">
                                        <div><img onClick={() => editItemHandler(item, index1)} src={item.menuItem.thumbNailUrl === undefined ? item.image : item.menuItem.thumbNailUrl} alt="" /></div>
                                    </div>
                                    <div className="cartItem">
                                        <div className="cartItemHeader">
                                            <div className="cartItemName" onClick={() => editItemHandler(item, index1)}>{item.description}</div>
                                            <div className="cartPrice">${item.price.toFixed(2)} x {item.quantity}</div>
                                        </div>
                                        <div className="cartItemModsDiv">
                                            {item.modifiers !== undefined &&
                                                // eslint-disable-next-line array-callback-return
                                                item.modifiers.map((modifierGroup, index) => {
                                                    let i = 0;
                                                    modifierGroup.modifiers.forEach(element => i += element.quantity);
                                                    if (i > 0) {
                                                        return (
                                                            <div key={index}>
                                                                {
                                                                    // eslint-disable-next-line array-callback-return
                                                                    modifierGroup.modifiers.map((modifier, index) => {
                                                                        if (modifier.quantity > 0) {
                                                                            return (
                                                                                <div className="cartItemMod" key={index}>
                                                                                    <div>
                                                                                        {modifier.modifier.menuItemOptionName !== undefined &&
                                                                                            <div>{modifier.modifier.menuItemOptionName.toUpperCase()}</div>
                                                                                        }
                                                                                        {modifier.modifier.menuItemOptionName === undefined &&
                                                                                            <div>
                                                                                                {modifier.modifier.modifierName.toUpperCase()}
                                                                                                {modifier.quantity > 1 &&
                                                                                                    <>{" "}x{modifier.quantity}</>
                                                                                                }
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                    <div>
                                                                                        {modifier.modifier.menuItemOptionName !== undefined &&
                                                                                            <div>
                                                                                                {modifier.modifier.amount > 0 &&
                                                                                                    <div>(${modifier.modifier.amount.toFixed(2)})</div>
                                                                                                }
                                                                                            </div>
                                                                                        }
                                                                                        {modifier.modifier.menuItemOptionName === undefined &&
                                                                                            <div>
                                                                                                {" "}
                                                                                                {modifier.modifier.amount > 0 &&
                                                                                                    <>
                                                                                                        {modifier.quantity === 1 &&
                                                                                                            <div>(+${modifier.modifier.amount.toFixed(2)})</div>
                                                                                                        }
                                                                                                        {modifier.quantity > 1 &&
                                                                                                            <div>(+${(modifier.modifier.amount * modifier.quantity).toFixed(2)})</div>
                                                                                                        }
                                                                                                    </>
                                                                                                    
                                                                                                }
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })
                                                                }
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="cartFooter">
                    {window.location.href.includes("/oo/") &&
                        <div className="cartTimeDiv">
                            <div className="cartTimeTitleDiv">
                                <div className="cartTimeTitle">Pick-Up Time</div>
                            </div>
                            <div className="cartAddonsContainer">
                                <div className="cartAddons">
                                    <div className="cartAddon" onClick={() => setTimeOption("ASAP")}>
                                        <input type="radio" checked={timeOption === "ASAP"} onChange={() => console.log()} />
                                        <div className="cartAddonDiv">ASAP (10-15 min) +$2.50</div>
                                    </div>
                                    <div className="cartAddon" onClick={() => setTimeOption("Normal")}>
                                        <input type="radio" checked={timeOption === "Normal"} onChange={() => console.log()} />
                                        <div className="cartAddonDiv">Normal (25-30 min)</div>
                                    </div>
                                    <div className="cartAddon" onClick={() => setTimeOption("Schedule")}>
                                        <input type="radio" checked={timeOption === "Schedule"} onChange={() => console.log()} />
                                        <div className="cartAddonDiv">Schedule</div>
                                        {timeOption === "Schedule" &&
                                            <DatePicker 
                                                showTimeSelect 
                                                style={{marginLeft: "8px"}} 
                                                selected={setDate} 
                                                onChange={(date) => setSetDate(date)}
                                                customInput={
                                                    <div>
                                                        {setDate.getDate()}/{setDate.getMonth()}/{setDate.getYear() + 1900}
                                                        {' '} at {' '}
                                                        {setDate.getHours() > 12 ? setDate.getHours() - 12 : setDate.getHours()}:
                                                        {setDate.getMinutes() < 10 ? "0" + setDate.getMinutes() : setDate.getMinutes()}
                                                        {setDate.getHours() > 12 ? "pm" : "am"}
                                                    </div>
                                                }
                                                minDate={currentDate}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    
                    <div className="cartAddonsDiv">
                        <div className="cartAddonsTitle">Add-Ons</div>
                        <div className="cartAddonsContainer">
                            <div className="cartAddons">
                                <div className="cartAddon" onClick={() =>setUtensils(!utensils)}>
                                    <input type="radio" checked={utensils} onChange={() => console.log()} />
                                    <div className="cartAddonDiv">Include Utensils?</div>
                                </div>
                                <div className="cartAddon" onClick={() =>setNapkins(!napkins)}>
                                    <input type="radio" checked={napkins} onChange={() => console.log()} />
                                    <div className="cartAddonDiv">Include Napkins?</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cartSubtotalDiv">
                        <div>Subtotal:</div>
                        <div>${orderHeader.total.toFixed(2)}</div>
                    </div>
                    <div className="cartCheckoutDiv">
                        <div 
                            className={orderHeader.orderDetails.length > 0 ? "cartClear" : "cartClear noCartItems"} 
                            onClick={orderHeader.orderDetails.length > 0 ? () => clearCartHandler() : null}
                        >
                            Clear Cart
                        </div>
                        {!window.location.href.includes("/checkout") &&
                            <div 
                                className={orderHeader.orderDetails.length > 0 ? "cartCheckout" : "cartCheckout noCartItems"} 
                                onClick={orderHeader.orderDetails.length > 0 ? () => navigate(location.pathname + "/checkout") : null}
                            >
                                Checkout
                            </div>
                        }
                        {window.location.href.includes("/di/") &&
                            <div className="cartUpdateButton" onClick={() => (updateCartDi())}> 
                                <svg viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M21,10.12H14.22L16.96,7.3C14.23,4.6 9.81,4.5 7.08,7.2C4.35,9.91 4.35,14.28 7.08,17C9.81,19.7 14.23,19.7 16.96,17C18.32,15.65 19,14.08 19,12.1H21C21,14.08 20.12,16.65 18.36,18.39C14.85,21.87 9.15,21.87 5.64,18.39C2.14,14.92 2.11,9.28 5.62,5.81C9.13,2.34 14.76,2.34 18.27,5.81L21,3V10.12M12.5,8V12.25L16,14.33L15.28,15.54L11,13V8H12.5Z" />
                                </svg>
                            </div>
                        }
                    </div>
                </div>
            </Offcanvas>
        </>  
    )
}


export default Cart;